import { render, staticRenderFns } from "./AudioSettings.vue?vue&type=template&id=79bca873&"
import script from "./AudioSettings.vue?vue&type=script&lang=js&"
export * from "./AudioSettings.vue?vue&type=script&lang=js&"
import style0 from "./AudioSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports